
import { defineComponent, PropType } from 'vue'
import { Campaign, CreditCard } from '@/types'
import { Selection, ShippingAddress, Payment } from '@/types/order'

import ProductSelectForm from './OrderForm/ProductSelectForm.vue'
import ShippingAddressFormCard from './OrderForm/ShippingAddressFormCard.vue'
import PaymentFormCard from './OrderForm/PaymentFormCard.vue'

export default defineComponent({
  components: {
    ProductSelectForm,
    ShippingAddressFormCard,
    PaymentFormCard
  },
  props: {
    campaign: {
      type: Object as PropType<Campaign>,
      required: true
    },
    selections: {
      type: Array as PropType<Selection[]>,
      required: true
    },
    shippingAddress: {
      type: Object as PropType<ShippingAddress>,
      required: true
    },
    payment: {
      type: Object as PropType<Payment>,
      required: true
    },
    isAddressRegistered: {
      type: Boolean,
      required: false,
      default: false
    },
    isCreditCardRegistered: {
      type: Boolean,
      required: false,
      default: false
    },
    registeredCreditCard: {
      type: Object as PropType<CreditCard>,
      required: false
    }
  },
  emits: ['change:selections', 'input:address', 'input:payment', 'edit-registered-card'],
  methods: {
    handleSelectionsChange (selections: Selection[]) {
      this.$emit('change:selections', selections)
    },
    handleAddressInput (address: ShippingAddress) {
      this.$emit('input:address', address)
    },
    handlePaymentInput (payment: Payment) {
      this.$emit('input:payment', payment)
    },
    handleEditRegisteredCard () {
      this.$emit('edit-registered-card')
    }
  }
})
